import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api';
import Loader from '../components/Loader';
import LlamadasInnovaChat from '../components/LlamadasInnovaChat';

// Flujos de voz (IVR sin IA): apagado por defecto; se activa por cuenta con su tarifa por minuto.
function FlujosVozAdmin({ clienteId }) {
  const btn = bg => ({ background: bg, color: '#fff', border: 'none', borderRadius: 8, padding: '8px 16px', cursor: 'pointer', fontWeight: 600, fontSize: 13 });
  const [cfg, setCfg] = useState(null);
  const [tarifa, setTarifa] = useState('');
  const [msg, setMsg] = useState(null);
  useEffect(() => {
    api.get(`/admin/flujos-voz/${clienteId}`).then(r => { setCfg(r.data); setTarifa(r.data.tarifa_minuto ?? ''); })
      .catch(() => setCfg({ error: true }));
  }, [clienteId]);
  const guardar = async activo => {
    setMsg(null);
    try {
      const r = await api.put(`/admin/flujos-voz/${clienteId}`, { activo, tarifa_minuto: tarifa === '' ? null : Number(tarifa) });
      setCfg(r.data); setMsg({ ok: true, txt: r.data.activo ? 'Flujos de voz activos' : 'Flujos de voz apagados' });
    } catch (e) { setMsg({ ok: false, txt: e.response?.data?.detail || 'No se pudo guardar' }); }
  };
  if (!cfg || cfg.error) return null;
  return (
    <div className="ic-card" style={{ background: 'var(--bg)', border: '1px solid var(--surface)', borderRadius: 12, padding: 20, marginBottom: 16 }}>
      <h3 style={{ color: 'var(--text)', fontSize: 14, fontWeight: 700, margin: '0 0 6px' }}>Flujos de voz (IVR sin IA)</h3>
      <p style={{ color: 'var(--text-3)', fontSize: 12, margin: '0 0 14px' }}>Llamadas con grabación o voz generada y respuestas por voz o tecla. Se cobra por minuto contestado con esta tarifa, aparte de la del agente IA.</p>
      <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
        <label style={{ fontSize: 12, color: 'var(--text-2)' }}>Tarifa COP/min</label>
        <input type="number" min={1} value={tarifa} onChange={e => setTarifa(e.target.value)}
          style={{ width: 110, padding: '8px 10px', background: 'var(--surface-3)', border: '1px solid var(--surface)', borderRadius: 8, color: 'var(--text)', fontSize: 13 }} />
        {cfg.activo
          ? <><button onClick={() => guardar(true)} style={btn('var(--accent-solid)')}>Guardar tarifa</button>
              <button onClick={() => guardar(false)} style={btn('var(--text-4)')}>Apagar</button></>
          : <button onClick={() => guardar(true)} style={btn('var(--success)')}>Activar</button>}
        <span style={{ fontSize: 12, fontWeight: 700, color: cfg.activo ? 'var(--success)' : 'var(--text-3)' }}>{cfg.activo ? 'Activo' : 'Apagado'}</span>
      </div>
      {msg && <div style={{ fontSize: 12, marginTop: 10, color: msg.ok ? 'var(--success)' : 'var(--danger)' }}>{msg.txt}</div>}
    </div>
  );
}

export default function AdminClienteDetalle() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [cliente, setCliente]   = useState(null);
  const [stats, setStats]       = useState(null);
  const [recargas, setRecargas] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [saving, setSaving]     = useState(false);
  const [sipVerif, setSipVerif]   = useState(null);
  const [sipVerifying, setSipVerifying] = useState(false);

  const verificarSip = async () => {
    setSipVerifying(true);
    setSipVerif(null);
    try {
      const r = await api.get(`/admin/clientes/${id}/sip/verificar`);
      setSipVerif(r.data);
    } catch {
      setSipVerif({ status: 'error', mensaje: 'Error al verificar la conexión' });
    }
    setSipVerifying(false);
  };
  const [msg, setMsg]           = useState('');
  const [editando, setEditando] = useState(false);
  const [form, setForm]         = useState({});

  useEffect(() => { cargar(); }, [id]);

  const cargar = async () => {
    setLoading(true);
    try {
      const [cRes, sRes, rRes] = await Promise.all([
        api.get(`/admin/clientes/${id}`),
        api.get(`/admin/clientes/${id}/stats`),
        api.get(`/admin/clientes/${id}/recargas`),
      ]);
      setCliente(cRes.data);
      setStats(sRes.data);
      setRecargas(rRes.data || []);
      setForm({
        saldo: cRes.data.saldo,
        tarifa_por_minuto: cRes.data.tarifa_por_minuto,
        llm_model: cRes.data.llm_model || 'gpt-4o',
        max_concurrentes: cRes.data.max_concurrentes || 3,
        sip_trunk_activo: cRes.data.sip_trunk_activo || false,
        sip_server: cRes.data.sip_server || '',
        sip_port: cRes.data.sip_port || '5060',
        sip_username: cRes.data.sip_username || '',
        sip_password: cRes.data.sip_password || '',
        sip_prefix_movil: cRes.data.sip_prefix_movil || '',
        sip_prefix_fijo: cRes.data.sip_prefix_fijo || '',
      });
    } catch(e) { console.error(e); }
    setLoading(false);
  };

  const guardar = async () => {
    setSaving(true);
    try {
      await api.patch(`/admin/clientes/${id}`, form);
      setCliente(prev => ({ ...prev, ...form }));
      setMsg('Guardado'); setEditando(false);
    } catch { setMsg('Error'); }
    setSaving(false);
  };

  const toggleStatus = async () => {
    const nuevo = cliente.status === 'active' ? 'suspended' : 'active';
    await api.patch(`/admin/clientes/${id}`, { status: nuevo });
    setCliente(prev => ({ ...prev, status: nuevo }));
    setMsg(nuevo === 'active' ? 'Cliente activado' : 'Cliente suspendido');
  };

  const eliminar = async () => {
    if (!window.confirm(`¿Eliminar permanentemente a ${cliente.nombre_empresa}? Esta acción no se puede deshacer.`)) return;
    try {
      await api.delete(`/admin/clientes/${id}`);
      navigate('/admin/clientes');
    } catch { setMsg('Error eliminando cliente'); }
  };

  const fmt = (n) => Number(n || 0).toLocaleString('es-CO', { minimumFractionDigits: 0 });
  const inp = { background: 'var(--bg)', border: '1px solid var(--surface-2)', borderRadius: 8, color: 'var(--text)', padding: '8px 12px', fontSize: 13, width: '100%', boxSizing: 'border-box' };
  const btn = (bg) => ({ background: bg, color: '#fff', border: 'none', borderRadius: 8, padding: '9px 18px', cursor: 'pointer', fontWeight: 600, fontSize: 13 });

  if (loading) return <Loader full />;
  if (!cliente) return <div style={{ color: 'var(--danger)', padding: 32 }}>Cliente no encontrado</div>;

  return (
    <div style={{ maxWidth: 900 }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 28 }}>
        <button onClick={() => navigate('/admin/clientes')} style={{ ...btn('var(--surface)'), padding: '8px 14px' }}>← Volver</button>
        <div style={{ flex: 1 }}>
          <h1 style={{ fontSize: 22, fontWeight: 700, color: 'var(--text)', margin: 0 }}>{cliente.nombre_empresa}</h1>
          <p style={{ color: 'var(--text-3)', fontSize: 13, margin: '4px 0 0' }}>{cliente.correo} · NIT: {cliente.nit_o_documento}</p>
        </div>
        <span style={{
          padding: '4px 14px', borderRadius: 20, fontSize: 12, fontWeight: 600,
          color: cliente.status === 'active' ? 'var(--success)' : 'var(--danger)',
          background: cliente.status === 'active' ? 'var(--success-soft)' : 'var(--danger-soft)',
          border: `1px solid ${cliente.status === 'active' ? 'rgba(52,211,153,0.2)' : 'var(--danger-soft)'}`,
        }}>{cliente.status === 'active' ? '● Activo' : '● Suspendido'}</span>
      </div>

      {msg && <div style={{ background: 'var(--surface)', borderRadius: 8, padding: '10px 16px', marginBottom: 16, color: 'var(--text)', fontSize: 13 }}>{msg}</div>}

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
        {/* Info básica */}
        <div className="ic-card" style={{ background: 'var(--bg)', border: '1px solid var(--surface)', borderRadius: 12, padding: 20 }}>
          <h3 style={{ color: 'var(--text)', fontSize: 14, fontWeight: 700, margin: '0 0 16px' }}>Información del cliente</h3>
          {[
            { label: 'Fecha registro', value: cliente.date_created ? new Date(cliente.date_created).toLocaleDateString('es-CO') : '-' },
            { label: 'Verificado', value: cliente.verificado ? 'Sí' : 'No verificado' },
            { label: 'Onboarding', value: cliente.onboarding_completado ? 'Completado' : 'Pendiente' },
            { label: 'Modelo IA', value: cliente.llm_model || 'gpt-4o' },
            { label: 'Concurrencia', value: `${cliente.max_concurrentes || 3} llamadas simultáneas` },
          ].map((f, i) => (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid var(--surface)' }}>
              <span style={{ fontSize: 12, color: 'var(--text-3)' }}>{f.label}</span>
              <span style={{ fontSize: 13, color: 'var(--text)', fontWeight: 500 }}>{f.value}</span>
            </div>
          ))}
        </div>

        {/* Estadísticas */}
        <div className="ic-card" style={{ background: 'var(--bg)', border: '1px solid var(--surface)', borderRadius: 12, padding: 20 }}>
          <h3 style={{ color: 'var(--text)', fontSize: 14, fontWeight: 700, margin: '0 0 16px' }}>Estadísticas del mes</h3>
          {[
            { label: 'Saldo actual',    value: `$${fmt(cliente.saldo)} COP`,              color: 'var(--text)' },
            { label: 'Llamadas',        value: stats?.llamadas_mes || 0,                  color: 'var(--text)' },
            { label: 'Minutos',         value: `${stats?.minutos_mes || 0} min`,           color: 'var(--text)' },
            { label: 'Ingresos mes',    value: `$${fmt(stats?.ingresos_mes)} COP`,         color: 'var(--text)' },
            { label: 'Total histórico', value: `$${fmt(stats?.ingresos_total)} COP`,       color: 'var(--text)' },
            { label: 'Recargas mes',    value: stats?.recargas_mes || 0,                  color: 'var(--text)' },
          ].map((f, i) => (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid var(--surface)' }}>
              <span style={{ fontSize: 12, color: 'var(--text-3)' }}>{f.label}</span>
              <span style={{ fontSize: 13, color: f.color, fontWeight: 600 }}>{f.value}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Configuración */}
      <div className="ic-card" style={{ background: 'var(--bg)', border: '1px solid var(--surface)', borderRadius: 12, padding: 20, marginBottom: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <h3 style={{ color: 'var(--text)', fontSize: 14, fontWeight: 700, margin: 0 }}>Configuración</h3>
          {!editando && <button onClick={() => setEditando(true)} style={btn('var(--accent-solid)')}>✏️ Editar</button>}
        </div>
        {editando ? (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            {[
              { label: 'Saldo COP', key: 'saldo', type: 'number' },
              { label: 'Tarifa/min', key: 'tarifa_por_minuto', type: 'number' },
              { label: 'Concurrencia máx', key: 'max_concurrentes', type: 'number' },
            ].map(f => (
              <div key={f.key}>
                <label style={{ fontSize: 11, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>{f.label}</label>
                <input style={inp} type={f.type} value={form[f.key] || ''} onChange={e => setForm(prev => ({ ...prev, [f.key]: e.target.value }))} />
              </div>
            ))}
            <div>
              <label style={{ fontSize: 11, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Modelo IA</label>
              <select style={{ ...inp, cursor: 'pointer' }} value={form.llm_model} onChange={e => setForm(prev => ({ ...prev, llm_model: e.target.value }))}>
                <option value="gpt-4o-mini">GPT-4o Mini (rápido y económico)</option>
                <option value="gemini-2.5-flash">Gemini 2.5 Flash ⭐ (más rápido, más barato)</option>
                <option value="gpt-4o">GPT-4o (más inteligente)</option>
                <option value="gpt-4.1">GPT-4.1</option>
                <option value="gpt-4.1-mini">GPT-4.1 Mini</option>
              </select>
            </div>
            {/* Troncal SIP propia */}
            <div style={{ gridColumn: 'span 2', background: 'var(--bg)', borderRadius: 10, padding: 16, border: '1px solid var(--surface-2)', marginTop: 4 }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
                <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--accent)' }}>Troncal SIP propia</span>
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                  <span style={{ fontSize: 12, color: 'var(--text-3)' }}>{form.sip_trunk_activo ? 'Habilitada' : 'Deshabilitada'}</span>
                  <input type="checkbox" checked={form.sip_trunk_activo} onChange={e => setForm(prev => ({ ...prev, sip_trunk_activo: e.target.checked }))} />
                </label>
              </div>
              {form.sip_trunk_activo && (
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                  <div style={{ gridColumn: 'span 2' }}>
                    <label style={{ fontSize: 11, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Servidor SIP</label>
                    <input style={inp} type="text" placeholder="ej: sip.4yes.com o 201.234.240.69" value={form.sip_server} onChange={e => setForm(prev => ({ ...prev, sip_server: e.target.value }))} />
                  </div>
                  <div>
                    <label style={{ fontSize: 11, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Puerto</label>
                    <input style={inp} type="text" placeholder="5060" value={form.sip_port} onChange={e => setForm(prev => ({ ...prev, sip_port: e.target.value }))} />
                  </div>
                  <div>
                    <label style={{ fontSize: 11, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Usuario</label>
                    <input style={inp} type="text" value={form.sip_username} onChange={e => setForm(prev => ({ ...prev, sip_username: e.target.value }))} />
                  </div>
                  <div style={{ gridColumn: 'span 2' }}>
                    <label style={{ fontSize: 11, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Contraseña</label>
                    <input style={inp} type="password" value={form.sip_password} onChange={e => setForm(prev => ({ ...prev, sip_password: e.target.value }))} />
                  </div>
                  <div>
                    <label style={{ fontSize: 11, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Prefijo móviles</label>
                    <input style={inp} type="text" placeholder="ej: 19157" value={form.sip_prefix_movil} onChange={e => setForm(prev => ({ ...prev, sip_prefix_movil: e.target.value }))} />
                  </div>
                  <div>
                    <label style={{ fontSize: 11, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Prefijo fijos</label>
                    <input style={inp} type="text" placeholder="ej: 888857" value={form.sip_prefix_fijo} onChange={e => setForm(prev => ({ ...prev, sip_prefix_fijo: e.target.value }))} />
                  </div>
                </div>
              )}
            </div>
            <div style={{ gridColumn: 'span 2', display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button onClick={() => setEditando(false)} style={btn('var(--surface)')}>Cancelar</button>
              <button onClick={guardar} disabled={saving} style={btn('var(--accent-solid)')}>{saving ? 'Guardando...' : '✓ Guardar'}</button>
            </div>
          </div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            {[
              { label: 'Saldo', value: `$${fmt(cliente.saldo)} COP` },
              { label: 'Tarifa/min', value: `$${cliente.tarifa_por_minuto}/min` },
              { label: 'Concurrencia', value: `${cliente.max_concurrentes || 3} simultáneas` },
              { label: 'Modelo IA', value: cliente.llm_model || 'gpt-4o' },
            ].map((f, i) => (
              <div key={i} style={{ background: 'var(--surface)', borderRadius: 8, padding: '12px 16px' }}>
                <div style={{ fontSize: 10, color: 'var(--text-3)', marginBottom: 4 }}>{f.label}</div>
                <div style={{ fontSize: 15, color: 'var(--text)', fontWeight: 600 }}>{f.value}</div>
              </div>
            ))}
          </div>
        )}
      </div>

      <LlamadasInnovaChat clienteId={id} />

      <FlujosVozAdmin clienteId={id} />

      {/* Historial recargas */}
      <div className="ic-card" style={{ background: 'var(--bg)', border: '1px solid var(--surface)', borderRadius: 12, padding: 20, marginBottom: 16 }}>
        <h3 style={{ color: 'var(--text)', fontSize: 14, fontWeight: 700, margin: '0 0 16px' }}>Historial de recargas</h3>
        {recargas.length === 0 ? (
          <p style={{ color: 'var(--text-3)', fontSize: 13 }}>Sin recargas registradas</p>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead><tr style={{ borderBottom: '1px solid var(--surface)' }}>
              {['Fecha', 'Monto', 'Estado'].map(h => (
                <th key={h} style={{ padding: '8px 12px', textAlign: 'left', fontSize: 10, color: 'var(--text-3)', textTransform: 'uppercase' }}>{h}</th>
              ))}
            </tr></thead>
            <tbody>
              {recargas.map((r, i) => (
                <tr key={i} style={{ borderBottom: '1px solid var(--surface-3)' }}>
                  <td style={{ padding: '10px 12px', color: 'var(--text-2)', fontSize: 13 }}>{r.date_created ? new Date(r.date_created).toLocaleDateString('es-CO') : '-'}</td>
                  <td style={{ padding: '10px 12px', color: 'var(--success)', fontWeight: 600, fontSize: 13 }}>${fmt(r.monto)} COP</td>
                  <td style={{ padding: '10px 12px' }}>
                    <span style={{
                      padding: '2px 10px', borderRadius: 20, fontSize: 11,
                      color: r.status === 'APROBADA' ? 'var(--success)' : r.status === 'RECHAZADA' ? 'var(--danger)' : 'var(--warning)',
                      background: r.status === 'APROBADA' ? 'var(--success-soft)' : r.status === 'RECHAZADA' ? 'var(--danger-soft)' : 'rgba(250,204,21,0.1)',
                    }}>{r.status || 'PENDIENTE'}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Acciones peligrosas */}
      <div style={{ background: '#1a0a0a', border: '1px solid #3f1e1e', borderRadius: 12, padding: 20 }}>
        <h3 style={{ color: 'var(--danger)', fontSize: 14, fontWeight: 700, margin: '0 0 16px' }}>Zona de peligro</h3>
        <div style={{ display: 'flex', gap: 12 }}>
          <button onClick={toggleStatus} style={btn(cliente.status === 'active' ? 'var(--danger)' : 'var(--success)')}>
            {cliente.status === 'active' ? '🔴 Suspender cliente' : '🟢 Activar cliente'}
          </button>
          <button onClick={eliminar} style={btn('#7f1d1d')}>🗑️ Eliminar cliente permanentemente</button>
        </div>
      </div>
    </div>
  );
}
